export default __webpack_public_path__ + "static/media/aliwangwang.e1b9147b.svg";